import {
  BACKEND_HTTP_PATH,
  APP_BUILD_ENV,
  SMILES_ENABLE,
  EXTERNAL_CSS_LINK,
  SEND_FRONT_LOGS_ENABLE,
} from 'src/config';
import { viewMode } from 'src/utils';
import axiosInstance from 'src/features/axiosInstance';

// const C_WEB_AUTO_CLASSIFIER_ENABLE - к этой константе из модуля APP_BUILD_ENV
// идет многократно обращение в проекте, но она нигде не задается
// - TODO - сделать ресерч и выпилить, если не нужна

// в константы выносим только названия сущностей/мутаций,
// которые переиспользуем/планируем переиспользовать
export const C_ANSWER_TEMPLATE_INTERPOLATION_CODES = 'C_ANSWER_TEMPLATE_INTERPOLATION_CODES';
export const C_APP_BUILD_ENV = 'C_APP_BUILD_ENV';
export const C_ATTACHMENT_MAX_COUNT = 'C_ATTACHMENT_MAX_COUNT';
export const C_ATTACHMENT_MAX_SIZE = 'C_ATTACHMENT_MAX_SIZE';
export const C_CUSTOM_INFO_AUTH_MAPPING = 'C_CUSTOM_INFO_AUTH_MAPPING';
export const C_AUTO_NOTIFICATION_INTERPOLATION_CODES = 'C_AUTO_NOTIFICATION_INTERPOLATION_CODES';
export const C_CANCELED_ACTIVITY_WITHOUT_PROCESSING = 'C_CANCELED_ACTIVITY_WITHOUT_PROCESSING';
export const C_CLOSE_CLASSIFIED_ACTIVITY_TIMEOUT = 'C_CLOSE_CLASSIFIED_ACTIVITY_TIMEOUT';
export const C_CUSTOMER_FILE_TRANSFER_ENABLE_BOT = 'C_CUSTOMER_FILE_TRANSFER_ENABLE_BOT';
export const C_CUSTOMER_FILE_TRANSFER_ENABLE_OPERATOR = 'C_CUSTOMER_FILE_TRANSFER_ENABLE_OPERATOR';
export const C_CUSTOMER_LOGIN_ANON_ENABLE = 'C_CUSTOMER_LOGIN_ANON_ENABLE';
export const C_CUSTOMER_LOGIN_ENABLED = 'C_CUSTOMER_LOGIN_ENABLED';
export const C_CUSTOMER_LOGIN_IDENT_ENABLE = 'C_CUSTOMER_LOGIN_IDENT_ENABLE';
export const C_EXTERNAL_CSS_LINK = 'C_EXTERNAL_CSS_LINK';
export const C_GET_LOST_MSG_PERIOD = 'C_GET_LOST_MSG_PERIOD';
export const C_HOST_SITE_TIMEOUT = 'C_HOST_SITE_TIMEOUT';
export const C_LDAP_ENABLED = 'C_LDAP_ENABLED';
export const C_MANDATORY_MARKERS_FOR_ACTIVITY = 'C_MANDATORY_MARKERS_FOR_ACTIVITY';
export const C_MAXIMUM_MESSAGE_LENGTH = 'C_MAXIMUM_MESSAGE_LENGTH';
export const C_NUMBER_DISPATCH_CRM_MESSAGES = 'C_NUMBER_DISPATCH_CRM_MESSAGES';
export const C_OPERATOR_FILE_TRANSFER_ACCESS_CHANNEL = 'C_OPERATOR_FILE_TRANSFER_ACCESS_CHANNEL';
export const C_OUTBOUND_ACTIVITY_ENABLED = 'C_OUTBOUND_ACTIVITY_ENABLED';
export const C_PERIOD_SEND_FRONT_LOGS = 'C_PERIOD_SEND_FRONT_LOGS';
export const C_POSTMESSAGE_AUTHENTICATION_ENABLE = 'C_POSTMESSAGE_AUTHENTICATION_ENABLE';
export const C_SEND_BY_ENTER_ENABLED = 'C_SEND_BY_ENTER_ENABLED';
export const C_SEND_FRONT_LOGS_ENABLE = 'C_SEND_FRONT_LOGS_ENABLE';
export const C_SMILES_ENABLE = 'C_SMILES_ENABLE';
export const C_SYSTEM_INFO_VISIBLE = 'C_SYSTEM_INFO_VISIBLE';
export const C_TEAM_LIMITS = 'C_TEAM_LIMITS';
export const C_TIME_OUT_CRM_MESSAGES = 'C_TIME_OUT_CRM_MESSAGES';
export const C_USER_AVATAR_SIZE = 'C_USER_AVATAR_SIZE';
export const C_VOICE_CHANNEL = 'C_VOICE_CHANNEL';
export const C_WEB_ATTACHMENT_MAX_SIZE = 'C_WEB_ATTACHMENT_MAX_SIZE';
export const C_MESSAGES_FEED_HISTORY_FOR_CURRENT_CHANNEL_ONLY = 'C_MESSAGES_FEED_HISTORY_FOR_CURRENT_CHANNEL_ONLY';
export const CHANNEL_EMAIL = 'EMAIL';
export const CHANNEL_NAME = 'CHANNEL_NAME';
export const CHANNEL_TELEGRAM = 'TELEGRAM';
export const CHANNEL_VK = 'VK';
export const UCCE_VERSION = 'UCCE_VERSION';
export const WIDGET_ID = 'WIDGET_ID';

export const CONFIG_PATH = `${BACKEND_HTTP_PATH}api/config`;
export const HIDE_WIDGET = 'HIDE_WIDGET';
export const SET_CONFIG_LOADED = 'SET_CONFIG_LOADED';

const data = {
  fetchingConfig: false,
  isFrame: false,
  mode: viewMode.current(),
  sync: false,
  [C_ANSWER_TEMPLATE_INTERPOLATION_CODES]: {
    '{ИМЯ_КЛИЕНТА}': 'customers_customers.first_name',
    '{ОТЧЕСТВО_КЛИЕНТА}': 'customers_customers.middle_name',
    '{ФАМИЛИЯ_КЛИЕНТА}': 'customers_customers.last_name',
  },
  [C_CUSTOM_INFO_AUTH_MAPPING]: {
    customer_id: 'adviserId',
  },
  [C_APP_BUILD_ENV]: APP_BUILD_ENV,
  [C_ATTACHMENT_MAX_COUNT]: { email: 3, web: 1 },
  [C_AUTO_NOTIFICATION_INTERPOLATION_CODES]: {
    '{ИМЯ_КЛИЕНТА}': 'customers_customers.first_name',
    '{ИМЯ_ОПЕРАТОРА}': 'users_users.first_name',
    '{ОТЧЕСТВО_КЛИЕНТА}': 'customers_customers.middle_name',
    '{ФАМИЛИЯ_КЛИЕНТА}': 'customers_customers.last_name',
  },
  [C_CLOSE_CLASSIFIED_ACTIVITY_TIMEOUT]: 0,
  [C_CUSTOMER_FILE_TRANSFER_ENABLE_BOT]: false,
  [C_CUSTOMER_FILE_TRANSFER_ENABLE_OPERATOR]: false,
  [C_CUSTOMER_LOGIN_ANON_ENABLE]: true,
  [C_CUSTOMER_LOGIN_IDENT_ENABLE]: false,
  [C_EXTERNAL_CSS_LINK]: EXTERNAL_CSS_LINK,
  [C_GET_LOST_MSG_PERIOD]: 60000,
  [C_HOST_SITE_TIMEOUT]: 3000,
  [C_LDAP_ENABLED]: false,
  [C_NUMBER_DISPATCH_CRM_MESSAGES]: 3,
  [C_MESSAGES_FEED_HISTORY_FOR_CURRENT_CHANNEL_ONLY]: false,
  [C_OPERATOR_FILE_TRANSFER_ACCESS_CHANNEL]: [],
  [C_OUTBOUND_ACTIVITY_ENABLED]: false,
  [C_PERIOD_SEND_FRONT_LOGS]: 60000,
  [C_POSTMESSAGE_AUTHENTICATION_ENABLE]: false,
  [C_SEND_FRONT_LOGS_ENABLE]: SEND_FRONT_LOGS_ENABLE || false,
  [C_SMILES_ENABLE]: SMILES_ENABLE,
  [C_SYSTEM_INFO_VISIBLE]: false,
  [C_TEAM_LIMITS]: {
    max_operators: 200,
    max_overseers: 20,
  },
  [C_TIME_OUT_CRM_MESSAGES]: 2000,
  [C_USER_AVATAR_SIZE]: 128,
  [C_VOICE_CHANNEL]: false,
  [CHANNEL_NAME]: null,
  [HIDE_WIDGET]: false,
  [UCCE_VERSION]: '',
  [WIDGET_ID]: 'default',
  [C_MANDATORY_MARKERS_FOR_ACTIVITY]: true,
};

const getters = {
  isUcEnv(state) {
    return state[C_APP_BUILD_ENV] === 'UNICREDIT';
  },
  isRbEnv(state) {
    return state[C_APP_BUILD_ENV] === 'ROSBANK';
  },
  isDefaultEnv(state) {
    return state[C_APP_BUILD_ENV] === 'default';
  },
};

const actions = {
  fetchConfig({ commit }, channelIdentifier) {
    commit('SET_FETCHING_CONFIG');
    if (channelIdentifier) {
      return axiosInstance.get(CONFIG_PATH, {
        params: {
          channel_identifier: channelIdentifier,
        },
      }).then((res) => commit(SET_CONFIG_LOADED, res.data));
    } return axiosInstance.get(CONFIG_PATH).then((res) => commit(SET_CONFIG_LOADED, res.data));
  },
  changeIframe({ commit }, isFrame) {
    commit('SET_ISFRAME', isFrame);
  },
  setViewMode({ commit }, mode) {
    commit('CHANGE_VIEWMODE', mode);
  },
};

const mutations = {
  SET_CONFIG_LOADED(state, res) {
    Object.keys(res).forEach((key) => {
      const value = res[key];
      state[key] = value;
      return value;
    });
    state.fetchingConfig = false;
    state.sync = true;
  },
  SET_FETCHING_CONFIG(state) {
    state.fetchingConfig = true;
  },
  CHANGE_CHANNEL_NAME(state, channelName) {
    state[CHANNEL_NAME] = channelName;
  },
  CHANGE_WIDGET_ID(state, widgetId) {
    state[WIDGET_ID] = widgetId;
  },
  CHANGE_HIDE_WIDGET(state, hideWidget) {
    state[HIDE_WIDGET] = hideWidget;
  },
  SET_ISFRAME(state, isFrame) {
    state.isFrame = isFrame;
  },
  CHANGE_VIEWMODE(state, mode) {
    viewMode.set(mode);
    state.mode = mode;
  },
  CHANGE_UCCE_VERSION(state, version) {
    state[UCCE_VERSION] = version;
  },
};

const store = {
  namespaced: true,
  state: data,
  getters,
  actions,
  mutations,
};

export default store;
